import { render, staticRenderFns } from "./manpower.vue?vue&type=template&id=850b844c"
import script from "./manpower.ts?vue&type=script&lang=js&external"
export * from "./manpower.ts?vue&type=script&lang=js&external"
import style0 from "./manpower.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports